import {
    Accordion,
    Carousel,
    Container,
} from "@peracto/peracto-blocks-tailwind";

import Hero from "./Hero";
import USPBlock from "./USPBlock";
import ImageAndText from "./ImageAndText";
import MenuItems from "./MenuItems";
import Products from "./Products";
import InfoPanel from "./InfoPanel";
import VideoCarousel from "./VideoCarousel";
import Articles from "./Articles";
import Reviews from "./Reviews";
import ProductComparison from "./ProductComparison";
import Trustpilot from "./Trustpilot";
import PanelGrid from "./PanelGrid";
import HubspotForm from "./HubspotForm";

export default {
    plugins: {
        content: [
            Carousel,
            Accordion,
            Hero,
            USPBlock,
            ImageAndText,
            MenuItems,
            Products,
            InfoPanel,
            VideoCarousel,
            Articles,
            Reviews,
            ProductComparison,
            Trustpilot,
            PanelGrid,
            HubspotForm,
        ],
        layout: [Container],
    },
};
